import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  values: number[];
  names: LangType[];
}

export const useReviewsByQrCodes = (): ChartProps => {
  const { t, getLocale } = useLang();
  const { list } = useDashboardStore();
  const data = list?.feedbacks_by_qr as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      const series = data.values.some((item) => item > 0)
        ? [{ name: t('Кол-во отзывов'), data: data.values }]
        : [];

      return {
        series,
        options: {
          chart: {
            type: 'bar',
            zoom: { enabled: false },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '42px',
              borderRadius: 8,
            },
          },
          xaxis: {
            categories: data.names.map((name) => getLocale(name)),
          },
          yaxis: [{}],
          colors: ['#A700FF'],
          dataLabels: {
            enabled: false,
          },
          grid: {
            show: false,
          },
          legend: {
            show: false,
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    label: 'Распределение количества отзывов по QR-кодам',
    subLabel:
      'Отчёт отображает, сколько отзывов приходится на разные QR-коды, позволяя оценить эффективность отдельных точек взаимодействия',
    type: 'bar',
    ...chartData,
  };
};
